import { languageMap } from ".."
import { clikeComment, markupLanguage } from "./shared"

languageMap.actionscript = markupLanguage(clikeComment)
